import { render, staticRenderFns } from "./ExportINIFile.vue?vue&type=template&id=0a2ad5d8"
import script from "./ExportINIFile.vue?vue&type=script&lang=js"
export * from "./ExportINIFile.vue?vue&type=script&lang=js"
import style0 from "./ExportINIFile.vue?vue&type=style&index=0&id=0a2ad5d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports